import { VFC } from "react";

import { TextInput } from "@portex-pro/ui-components";
import Text from "components/Text";
import { useShipmentDetails } from "features/shipments/provider/ShipmentDetailsProvider";
import { Trans } from "react-i18next";

const QuoteNumber: VFC = () => {
  const { patch, patchedShipment } = useShipmentDetails();

  return (
    <div>
      <Text size="medium" typographyProps={{ style: { marginBottom: "8px" } }}>
        <Trans i18nKey="shipmentDetailsStep.quoteNumberOptional" ns="shipper" components={[<strong></strong>]} />
      </Text>
      <TextInput
        fullWidth
        value={patchedShipment.quoteNumber}
        onChange={(ev) => patch({ quoteNumber: ev.target.value })}
      />
    </div>
  );
};

export default QuoteNumber;
